import React from 'react';
import { ArrowRightIcon, CheckIcon, MapPinIcon, SparklesIcon } from 'lucide-react';
import { activeAlert, resolvedAlert } from '../../data/avis';
export function ImportantForYou() {
  return <section aria-labelledby="important-title" className="mt-10" data-id="element-312" data-mp="2t2bk60ha45ez">
      <h2 id="important-title" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-313" data-mp="2t0gygjy6o99u">
        Important for you
      </h2>

      <article className="mt-4 overflow-hidden rounded-3xl border border-slate-200 bg-white" data-id="element-314" data-mp="3kuiygu9bb5q7">
        <div className="border-l-4 border-red-600 p-6 sm:p-7" data-id="element-315" data-mp="3grw6mtcn5kt0">
          <div className="flex flex-wrap items-center gap-3" data-id="element-316" data-mp="3gqbdn85z69x9">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-red-600 px-3 py-1 text-xs font-bold uppercase tracking-wider text-white" data-id="element-317" data-mp="3bs1dsk9b2l5b">
              Urgent
            </span>
            <span className="text-sm text-slate-500" data-id="element-318" data-mp="20f78xdrleuur">{activeAlert.since}</span>
          </div>

          <h3 className="mt-3 text-xl font-extrabold leading-tight text-ville-navy sm:text-2xl" data-id="element-319" data-mp="1ve1g7fxxn7l8">
            {activeAlert.title}
          </h3>
          <p className="mt-2 max-w-2xl text-[15px] leading-relaxed text-slate-600" data-id="element-320" data-mp="2f9ztgptva8qb">{activeAlert.summary}</p>

          <p className="mt-4 inline-flex flex-wrap items-center gap-2 rounded-full bg-slate-50 px-4 py-2 text-sm" data-id="element-321" data-mp="2jbd217ocgq0x">
            <MapPinIcon className="h-4 w-4 text-red-600" aria-hidden="true" data-id="element-322" data-mp="2acrcutodacr6" />
            <span className="font-bold text-ville-navy" data-id="element-323" data-mp="2aeub20zobc6z">{activeAlert.address}</span>
            <span className="text-slate-500" data-id="element-324" data-mp="1vmtr0kdwtz55">· {activeAlert.addressLabel}</span>
          </p>

          <div className="mt-6 grid gap-4 sm:grid-cols-2" data-id="element-325" data-mp="20g4r82o7vho3">
            <div className="rounded-2xl bg-slate-50 p-4" data-id="element-326" data-mp="1mo84ke5bhzz3">
              <p className="text-xs font-bold uppercase tracking-wider text-slate-500" data-id="element-327" data-mp="1mllxsgq93ohx">What concerns you</p>
              <p className="mt-1.5 text-sm leading-relaxed text-ville-navy" data-id="element-328" data-mp="1cp93phqsn8mn">{activeAlert.concerns}</p>
            </div>
            <div className="rounded-2xl bg-slate-50 p-4" data-id="element-329" data-mp="1hovhpteg4swi">
              <p className="text-xs font-bold uppercase tracking-wider text-slate-500" data-id="element-330" data-mp="1hqgb3fp0y5ss">To do</p>
              <p className="mt-1.5 text-sm leading-relaxed text-ville-navy" data-id="element-331" data-mp="yltnzi6fwky9">{activeAlert.todo}</p>
            </div>
          </div>

          <div className="mt-6 flex flex-wrap items-center gap-3" data-id="element-332" data-mp="otnwsao0i7k4">
            <a href="#official-notice" className="inline-flex items-center gap-2 rounded-full bg-ville-navy px-5 py-2.5 text-sm font-bold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-333" data-mp="ortaot1089eg">
              View the instructions
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-334" data-mp="17ikjnth2xxsb" />
            </a>
            <a href="#official-notice" className="text-sm font-bold text-ville-navy underline underline-offset-4 hover:text-ville-indigo" data-id="element-335" data-mp="12ksn2m5hpnhs">
              Read the official notice
            </a>
          </div>

          <div className="mt-6 rounded-2xl border border-slate-200 p-4" data-id="element-336" data-mp="22tscitz6uy5l">
            <p className="flex items-center gap-2 text-sm font-bold text-ville-indigo" data-id="element-337" data-mp="22ro0for4ysu8">
              <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-338" data-mp="27qiuxnygu5u6" />
              Ask ATNA
            </p>
            <ul className="mt-3 flex flex-wrap gap-2" data-id="element-339" data-mp="2cpvfu35s12u4">
              {activeAlert.questions.map(question => <li key={question} data-id="element-340" data-mp="2mhhzmnw6ka8h">
                  <button type="button" className="rounded-full bg-slate-50 px-3.5 py-1.5 text-sm text-slate-600 transition-colors duration-150 ease-ville hover:bg-ville-indigo-soft hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-341" data-mp="2mggdnodmm3bz">
                    {question}
                  </button>
                </li>)}
            </ul>
          </div>
        </div>
      </article>

      <article className="mt-3 flex flex-wrap items-center gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4" data-id="element-342" data-mp="162gi0pltczuj">
        <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-ville-indigo-soft text-ville-indigo" aria-hidden="true" data-id="element-343" data-mp="2wisdzun4rgtc">
          <CheckIcon className="h-5 w-5" data-id="element-344" data-mp="35l1mkeyu9043" />
        </span>
        <div className="min-w-0 flex-1" data-id="element-345" data-mp="35ki7d60koptr">
          <h3 className="font-bold text-ville-navy" data-id="element-346" data-mp="31jger815vc0r">{resolvedAlert.title}</h3>
          <p className="text-sm text-slate-600" data-id="element-347" data-mp="31hc0bw5myum8">{resolvedAlert.detail}</p>
        </div>
        <button type="button" className="text-sm font-semibold text-slate-500 underline underline-offset-4 transition-colors duration-150 ease-ville hover:text-ville-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-348" data-mp="2du3w7hjy1rls">
          Remove
        </button>
      </article>
    </section>;
}